import { XML_Scale } from "./XML_Scale";
import { RoundTo3 } from "./RoundTo3";
import { XML_Cmd4 } from "./XML_Cmd4";
import { XML_Param4 } from "./XML_Param4";
import { kMiniTriWidth, kTriAnnoW } from "../constants";

export function XML_DrawTriPPT(
  bounds,
  boxShape,
  borderThickness,
  triColor,
  triPosition,
  borderColor,
  dashColor,
  subTriColor,
  drawElement,
  layer
) {
  var tSize = XML_Scale(kTriAnnoW, drawElement, layer);

  if (triPosition)
    XML_Cmd4(
      "ltri",
      RoundTo3(bounds.fLeft),
      RoundTo3(bounds.fTop),
      RoundTo3(tSize),
      RoundTo3(tSize),
      drawElement
    );
  else
    XML_Cmd4(
      "rtri",
      RoundTo3(bounds.fRight - tSize),
      RoundTo3(bounds.fTop),
      RoundTo3(tSize),
      RoundTo3(tSize),
      drawElement
    );
  XML_Param4("p", triColor, borderColor, borderThickness, 0, drawElement);

  if (subTriColor != null) {
    var subTSize = XML_Scale(kMiniTriWidth, drawElement, layer);

    if (triPosition)
      XML_Cmd4(
        "ltri",
        RoundTo3(bounds.fLeft),
        RoundTo3(bounds.fTop + subTSize),
        RoundTo3(subTSize),
        RoundTo3(subTSize),
        drawElement
      );
    else
      XML_Cmd4(
        "rtri",
        RoundTo3(bounds.fRight - subTSize),
        RoundTo3(bounds.fTop + subTSize),
        RoundTo3(subTSize),
        RoundTo3(subTSize),
        drawElement
      );
    XML_Param4("p", subTriColor, borderColor, 0, 0, drawElement);
  }
}
